var viewer_rtlignore_default = {
  "gallery_container": "q8Fc6",
  "imageTitleContainer": "kDwWG",
  "clickableItem": "pcBmZ",
  "prerender": "Vn86O",
  "expandButton": "Bk8xb",
  "itemContainer": "iNmt-",
  "expandIcon": "HpxaB",
  "itemOverlay": "_39w3U",
  "imageTitle": "huvUY",
  "pointer": "gVbLt",
  "fadeIn": "N7K-m",
  "changing_background": "VrO6c"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
